export default __webpack_public_path__ + "static/media/9.cc67302f.jpg";